export class KpiCaptiondata{
	columnName: string;
	caption:string;
}
export class KpiObjectData {
	public kpiId: number;
	public kpiName: string;
	public kpiDefinition: string;
	public kpiDefinitionDetailed: string;
	public kpiSelectStatement: string;
	public measureDefinition: string;
	public refMeasureDefinition: string;
	public kpiGroup1: string;
	public kpiGroup2: string;
	public kpiGroup3: string;
	public kpiGroup4: string;
	public kpiGroup5: string;
	public kpiGroup6: string;
	public minMaxPeriods: number;
	public periodDefinition: string;
	public landingPageDisplay: number;

	public formatQty: string;
	public formatQtyResolved: string;
	public formatQtyPostfix: string = "";

	public formatQtyRef: string;
	public formatQtyRefResolved: string;
	public formatQtyRefPostfix: string = "";

	public sortOrder: number;
	public chartType: string;
	public chartMin: number;
	public chartMax: number;
	public positiveIsGood: number;
	public chartNumberOfEntries: number;
	public chartMarkerLow: number;
	public chartMarkerHigh: number;
	public chartStartsAtZero: boolean;
	public chartMinorInterval: number;
	public chartAngleMin: number;
	public chartAngleMax: number;

	public helpPageId: number;

	public Initialize() {
		let formatQtySplit: string[] = this.formatQty.split(' ');

		this.formatQtyResolved = formatQtySplit[0];
		if (formatQtySplit.length > 1) {
			this.formatQtyPostfix = formatQtySplit[1];
		}

		let formatQtyRefSplit: string[] = this.formatQtyRef.split(' ');

		this.formatQtyRefResolved = formatQtyRefSplit[0];
		if (formatQtyRefSplit.length > 1) {
			this.formatQtyRefPostfix = formatQtyRefSplit[1];
		}
		
	} 
}
